$('.grid .slider').slick({
    dots: true,
    infinite: true,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 2000,
    appendDots: '.grid .slider .dots',
    slide: '.grid .slider .slide'
});

$('.grid-overflow-2').slick({
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 4000,
    infinaite: true,
    fade: true,
    pauseOnHover: false,
    pauseOnFocus: false
});
